<snelstart-ui-details
        [config]="detailsConfig"
        [entityId]="id"
        title="{{id}}"
>
    <snelstart-ui-details-content>
        <snelstart-venture-fiscaal-feature-voorschot
                *ngIf="id ==='Voorschot'"></snelstart-venture-fiscaal-feature-voorschot>
        <snelstart-venture-fiscaal-feature-inkomen
                *ngIf="id ==='Aanvrager'"></snelstart-venture-fiscaal-feature-inkomen>
        <snelstart-venture-fiscaal-feature-partner
                *ngIf="id ==='Partner'"></snelstart-venture-fiscaal-feature-partner>
        <snelstart-venture-fiscaal-feature-kinderen
                *ngIf="id ==='Kinderen'"></snelstart-venture-fiscaal-feature-kinderen>
        <snelstart-venture-fiscaal-feature-kinderopvangtoeslag
                *ngIf="id ==='Kinderopvang'"></snelstart-venture-fiscaal-feature-kinderopvangtoeslag>
        <snelstart-venture-fiscaal-feature-huurtoeslag
                *ngIf="id ==='Huurwoning'"></snelstart-venture-fiscaal-feature-huurtoeslag>
        <snelstart-venture-fiscaal-feature-berekening
                *ngIf="id ==='Berekening'"></snelstart-venture-fiscaal-feature-berekening>
    </snelstart-ui-details-content>

    <snelstart-ui-details-buttons>
        <snelstart-ui-button type="primary"
                             class="me-2"
                             [config]="config()"
                             *ngIf="!showButtonOpslaan(id)"
        >
            Opslaan
        </snelstart-ui-button>

        <snelstart-ui-button *ngIf="showButtonInfo(id)"
                             type="secondary"
                             (click)="this.showDialogInfo()">
            Toelichting
        </snelstart-ui-button>

    </snelstart-ui-details-buttons>

    <snelstart-ui-dialog-definition id="toelIB" title="Toelichting bij '{{id}}'"
                                    size="lg"
                                    [(visible)]="dialogInfoVisible">
        <snelstart-ui-dialog-body>
            <snelstart-venture-fiscaal-feature-tekst-aanvrager
                    *ngIf="this.id ==='Aanvrager'"></snelstart-venture-fiscaal-feature-tekst-aanvrager>
            <snelstart-venture-fiscaal-feature-tekst-partner
                    *ngIf="this.id ==='Partner'"></snelstart-venture-fiscaal-feature-tekst-partner>
            <snelstart-venture-fiscaal-feature-tekst-kinderen
                    *ngIf="this.id ==='Kinderen'"></snelstart-venture-fiscaal-feature-tekst-kinderen>
            <snelstart-venture-fiscaal-feature-tekst-kinderopvang
                    *ngIf="this.id ==='Kinderopvang'"></snelstart-venture-fiscaal-feature-tekst-kinderopvang>
            <snelstart-venture-fiscaal-feature-tekst-huurtoeslag
                    *ngIf="this.id ==='Huurwoning'"></snelstart-venture-fiscaal-feature-tekst-huurtoeslag>

            <!-- algemene informatie van Belastingdienst-->
            <div class="accordion" id="accordionExample" style="margin-top: -25px;">

                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingMeer">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseMeer" aria-expanded="false" aria-controls="collapseMeer">
                            Meer informatie over toeslagen
                        </button>
                    </h2>
                    <div id="collapseMeer" class="accordion-collapse collapse" aria-labelledby="headingMeer"
                         data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            De Belastingdienst heeft online uitgebreide informatie over de
                            toeslagen beschikbaar.
                            <div class="space20"></div>
                            <snelstart-ui-button size="small" type="secondary"
                                                 iconRight="arrow-up-right-from-square">
                                <a target="_blank"
                                   href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/toeslagen/hoe_werken_toeslagen/">
                                    Uitgebreidere informatie toeslagen
                                </a>

                            </snelstart-ui-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="accordion" id="accordionPdf">

                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingPdf">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapsePdf" aria-expanded="false" aria-controls="collapsePdf">
                           Toeslagenkaart
                        </button>
                    </h2>
                    <div id="collapsePdf" class="accordion-collapse collapse" aria-labelledby="headingPdf"
                         data-bs-parent="#accordionPdf">
                        <div class="accordion-body">
                            Bekijk de Toeslagenkaart {{this.allowanceEntity.year}} van de Belastingdienst voor alle belangrijke bedragen voor de toeslagen.
                            <div class="space20"></div>
                            <snelstart-ui-button size="small" type="secondary"
                                                 iconRight="arrow-up-right-from-square">
                                <a target="_blank"
                                   href="https://download.belastingdienst.nl/toeslagen/docs/toeslagenkaart_2025_tg7101z51pl.pdf">
                                   Toeslagenkaart {{this.allowanceEntity.year}} (pdf)
                                </a>

                            </snelstart-ui-button>
                        </div>
                    </div>
                </div>
            </div>
        </snelstart-ui-dialog-body>

        <snelstart-ui-dialog-buttons class="d-flex mt-2">
            <snelstart-ui-button id="sluiten" type="primary" icon="check" btn-x>Afsluiten
            </snelstart-ui-button>
        </snelstart-ui-dialog-buttons>

    </snelstart-ui-dialog-definition>

</snelstart-ui-details>
